import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {CompanyRouteContextService} from '@services/company-route-context.service';
import {CompanyService} from '@services/company.service';
import {DatePipe} from '@angular/common';
import {ITransmitItem} from '@models/workspace.interface';

@Component({
  selector: 'app-company-transmettre',
  imports: [DatePipe],
  templateUrl: './company-transmettre.html'
})
export class CompanyTransmettre implements OnInit {
  private readonly routeContext = inject(CompanyRouteContextService);
  private readonly companyService = inject(CompanyService);

  loading: WritableSignal<boolean> = signal(false);
  items: WritableSignal<ITransmitItem[]> = signal([]);

  ngOnInit(): void {
    this.loadItems();
  }

  loadItems(): void {
    const siret = this.routeContext.currentSiret();
    if (!siret) return;
    this.loading.set(true);
    this.companyService.getTransmitItems(siret).subscribe({
      next: (items) => {
        this.items.set(items);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }
}
